import { ColumnHelper } from "@tanstack/react-table";
import { ShortlistWithScores } from "PFApp/components/resource_table_toggle/hooks/use_shortlist_items";
import { Typography } from "PFComponents/typography";
import { ObjectWithProfileName } from "PFCore/helpers/profile";
import { Activity } from "PFTypes";

import { WmCell } from "./wm_cell";

type CreateWmColumnArgs = {
  headerLabel: string;
  activity: Activity;
  isUnbiasedMode: boolean;
  getUnbiasedProfileName: (profile: Partial<ObjectWithProfileName>, isUnbiasedMode?: boolean) => string;
  size?: number;
};

export const createWmColumn = (
  columnHelper: ColumnHelper<ShortlistWithScores>,
  { headerLabel, activity, isUnbiasedMode, getUnbiasedProfileName, size }: CreateWmColumnArgs
) =>
  columnHelper.accessor((row) => row, {
    id: "wm",
    header: () => (
      <Typography withMargin variant="labelRegular">
        {headerLabel}
      </Typography>
    ),
    cell: (info) => <WmCell profile={info.getValue().profile} activity={activity} />,
    sortingFn: (rowA, rowB) => {
      const nameA = getUnbiasedProfileName(rowA.original.profile, isUnbiasedMode)?.toLowerCase() ?? "";
      const nameB = getUnbiasedProfileName(rowB.original.profile, isUnbiasedMode)?.toLowerCase() ?? "";
      return nameA.localeCompare(nameB);
    },
    sortDescFirst: false,
    sortUndefined: "last",
    size
  });
